import React, { FC, useState } from 'react'
import classNames from 'classnames'

import { IconMoon, Typography } from '@/atoms'
import { Spacer } from '@/layout'
import {
  TextCardTitleProps,
  TextCardBodyProps,
  TextCardProps,
  TextCardLinkProps,
} from '@/types'
import { getStyledElementProps } from '@/utils'
import styles from './text-card.module.scss'

export const TextCardTitle: FC<TextCardTitleProps> = ({
  children,
  ...props
}) => {
  return (
    <div className={styles['title']}>
      <Typography variant={'headline-3'} typographyColor={'gray-6'} {...props}>
        {children}
      </Typography>
    </div>
  )
}

export const TextCardBody: FC<TextCardBodyProps> = ({ children, ...props }) => {
  return (
    <div className={styles['body']}>
      <Typography
        variant={'body-1'}
        tag={'span'}
        typographyColor={'gray-6'}
        {...props}
      >
        {children}
      </Typography>
    </div>
  )
}

export const TextCardLink: FC<TextCardLinkProps> = ({ children, ...props }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  const getIcon = () =>
    isHovered && <IconMoon name={'icon-arrow-red-1'} size={'xs'} />
  return (
    <div
      className={styles['link']}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Typography
        variant={'body-1'}
        tag={'span'}
        typographyColor={'red-5'}
        {...props}
      >
        {children}
      </Typography>
      {getIcon()}
    </div>
  )
}

export const TextCard: FC<TextCardProps> = ({
  children,
  variant = 'default',
  image,
  alt = '',
  width = '50',
  height = '50',
  loading = 'lazy',
  ...props
}) => {
  const styledProps = getStyledElementProps(
    props,
    classNames(styles['root'], styles[variant])
  )
  return (
    <div {...styledProps}>
      {image && (
        <img
          className={styles['image']}
          src={image}
          alt={alt}
          width={width}
          height={height}
          loading={loading}
        />
      )}
      {children}
      <Spacer variant={'horizontal'} size={'8x'} />
    </div>
  )
}
